<template>
  <div v-show="isShowModal">
    <div class="spx-modal h-100 justify-content-center">
      <div
        class="spx-modal-body mx-auto"
        style="
          width: 520px !important;
          max-width: 520px !important;
          padding-bottom: 0;
        "
      >
        <div class="modal-header pt-0">
          <button
            type="button"
            class="btn-close"
            v-on:click="closeModal"
          ></button>
          <h5 class="modal-title">Contact Details</h5>
        </div>
        <div class="modal-body">
          <p class="font-medium">{{ contentDetail.registration_no }}</p>
          <div class="row">
            <div class="col-md-5">
              <label>Candidate Full Name</label>
            </div>
            <div
              class="col-md-7 text-md-left"
              style="word-break: break-all !important"
            >
              <p class="font-medium">
                {{ contentDetail.first_name }} {{ contentDetail.middle_name }}
                {{ contentDetail.last_name }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5"><label>Contact Full Name</label></div>
            <div class="col-md-7 text-md-left">
              <p class="font-medium">
                {{
                  contentDetail.family_details_contact
                    ? contentDetail.family_details_contact.contact_full_name
                    : "-"
                }}
              </p>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-5"><label>Address</label></div>
            <div class="col-md-7 text-md-left">
              <p class="font-medium">
                {{
                  contentDetail.family_details_contact
                    ? contentDetail.family_details_contact.address
                    : "-"
                }}
                {{ contentDetail.family_details?.goan }}
                <!-- {{ contentDetail.family_details?.goan }} -->
                {{ contentDetail.family_details?.taluka?.name }}
                {{ contentDetail.family_details?.district?.name }}
                <!-- {{ contentDetail.family_details?.state?.name }} -->
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5"><label class="">Email</label></div>
            <div class="col-md-7 text-md-left">
              <p class="font-medium">
                {{
                  contentDetail &&
                  contentDetail.family_details &&
                  contentDetail.family_details.email
                    ? contentDetail.family_details.email
                    : "-"
                }}
              </p>
            </div>
          </div>
          <div
            class="row mt-2"
            v-if="
              contentDetail &&
              contentDetail.familty_phone_numbers_contact &&
              contentDetail.familty_phone_numbers_contact.length > 0
            "
          >
            <div class="col-md-12">
              <p class="font-medium">Phone Numbers</p>
            </div>
          </div>
          <div
            class="row"
            v-for="(data, index) in contentDetail.familty_phone_numbers_contact"
            :key="index"
          >
            <div class="col-md-5" v-if="data.is_hidden == 'N'">
              <label class="">{{ data.type }}</label>
            </div>
            <div class="col-md-7 text-md-left" v-if="data.is_hidden == 'N'">
              <p class="font-medium">
             <span style="max-width: 78% !important;display: inline-block !important;width: 51% !important;">   {{ data.phone }}</span>
                <i
                  :style="
                    data.is_whatsapp == 'Y'
                      ? 'opacity: 1;margin-top: 6px;'
                      : 'opacity: 0.5;margin-top: 6px;'
                  "
                  class="bx bxl-whatsapp h5 text-success mr-2 cursor-pointer"
                ></i>
                <i
                  :style="
                    data.is_phone == 'Y'
                      ? 'opacity: 1;margin-top: 6px;'
                      : 'opacity: 0.5;margin-top: 6px;'
                  "
                  class="bx bxs-phone h5 cursor-pointer"
                ></i
                >
              </p>
            </div>
          </div>
          <!-- <div
            class="row"
            v-if="contentDetail.mobile_country_code && contentDetail.mobile"
          >
            <div class="col-md-5"><label class="">Phone Number</label></div>
            <div class="col-md-7 text-md-left">
              <p class="font-medium">
                {{ contentDetail.mobile_country_code
                }}{{ contentDetail.mobile }}
              </p>
            </div>
          </div> -->
          <!-- <div class="row">
            <div class="col-md-5"><label class="">Email</label></div>
            <div class="col-md-7 text-md-left">
              <p class="font-medium">{{ contentDetail.email }}</p>
            </div>
          </div> -->
          <div class="row">
            <div class="col-md-5">
              <label class="">Contact Viewed on</label>
            </div>
            <div class="col-md-7 text-md-left">
              <p class="font-medium">
                {{
                  contentDetail.profile_view
                    ? $helperService.getFormatedDate(
                        contentDetail.profile_view.created_at
                      )
                    : ""
                }}
              </p>
            </div>
          </div>
          <div class="text-center mt-3">
            <a
              class="cursor-pointer"
              style="color: var(--brand-clr2)"
              v-on:click="smsEmailUserDetails(contentDetail.uuid)"
              >Email these details to me</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="spx-modal-background"></div>
  </div>
</template>
<script>
export default {
  name: "DeleteModal",
  data() {
    return {
      isShowModal: false,
      showLoader: false,
      title: "Alert",
      body: "Are you sure you want to delete",
      obj: {},
      contentDetail: {},
    };
  },
  mounted() {},
  methods: {
    showModal(obj) {
      this.contentDetail = obj;
      this.isShowModal = true;
    },
    closeModal() {
      this.contentDetail = {};
      this.isShowModal = false;
    },
    smsEmailUserDetails(uuid) {
      this.$api
        .getAPI({
          _action: "/email-detail/" + uuid,
        })
        .then(() => {
          this.$notify({
            type: "success",
            text: "User details are successfully sent to your registered email and mobile number",
          });
          this.$refs.viewContactmodel.closeModal();
        })
        .catch(() => {});
    },
  },
};
</script>
